var app = app || {};

/**
 * Google Analytics helper
 * @module app.ga
 */
app.ga = (function() {
    "use strict";
    /**
     * @memberof APP
     */
    var useDebug = false,
        self = {
        
        /**
         * Analytics
         * ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
         */
        track: function(category, action, label, value) {
            // don't track in preview mode
            if (app.pws && app.pws.isPreview()) return;

            if (typeof ga !== 'undefined') {
                if (!category) {
                    category = 'Admin';
                }

                ga('send', 'event', category, action, label, value);

                var gaDebug = {
                    category: category || '',
                    action: action || '',
                    label: label || '',
                    value: value || ''
                };

                self.log(gaDebug);
            }

            // v4 events
            if (typeof gtag !== 'undefined') {
                self.log('translate v3 to v4 for category '+ category);

                var type = '',
                    data = false,
                    pieces = [0,0];

                if (category.indexOf('EwM-') > -1) {
                    pieces = category.split('-');
                    category = 'ewm';
                }

                // yl.com enroll callback
                if (category.indexOf('enroll-') > -1) {
                    pieces = category.split('-');
                    category = 'enroll';
                }

                switch (category.toLowerCase()) {
                    case 'product':
                        //
                    break;
                    case 'ewm':
                        // bundle view/purchase
                        type = 'bundle';
                        data = {
                            action: action,
                            member_id: pieces[1],
                            bundle_slug: label
                        }
                    break;
                    case 'enroll':
                        // yl.com enroll callback
                        var ids = action.split('|');

                        type = 'enroll';
                        data = {
                            action: 'enroll',
                            customer_id: pieces[1],
                            sponsor_id: ids[0],
                            enroller_id: ids[1]
                        }
                    break;
                }

                if (data) {
                    self.event(type, data);
                }
            }
        },

        /**
         * V4 events
         */
        event: function(type, data) {
            // don't track in preview mode
            if (app.pws && app.pws.isPreview()) return;

            if (typeof gtag !== 'undefined') {
                gtag('event', type, data);
            }

            var gaDebug = {
                type: type,
                data: data
            };

            self.log(gaDebug);
        },

        /**
         * push an event or config to dataLayer directly
         */
        pushData: function(obj) {
            if (window.dataLayer) {
                window.dataLayer.push(obj);
            }
        },
        
        /**
         * Analytics pageview
         * ga('send', 'pageview', [page], [fieldsObject]);
         */
        pageView: function(page) {
            if (typeof ga !== 'undefined') {
                var hash = app.main.getHash();

                if (!page) {
                    page = decodeURIComponent(window.location.pathname + hash);
                }
                
                var dimensions = {
                    'dimension2': app.auth.getProfile().member_id,
                    'dimension6': app.auth.getProfile().country,
                    'dimension7': app.auth.getProfile().culture
                };
                
                ga('set', 'page', page);
                ga('send', 'pageview', dimensions);
            }
        },

        /**
         * Simple debug
         */
        log: function(obj) {
            if (useDebug === true) {
                console.log(obj);
            }
        }
    };

    return self;
}());
